import { render, staticRenderFns } from "./PrivateExerciseItemPage.vue?vue&type=template&id=e5051738&"
import script from "./PrivateExerciseItemPage.vue?vue&type=script&lang=js&"
export * from "./PrivateExerciseItemPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports